var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66669 7.99998C2.66669 7.63179 2.96516 7.33331 3.33335 7.33331H12.6667C13.0349 7.33331 13.3334 7.63179 13.3334 7.99998C13.3334 8.36817 13.0349 8.66665 12.6667 8.66665H3.33335C2.96516 8.66665 2.66669 8.36817 2.66669 7.99998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52858 2.86195C7.78892 2.6016 8.21103 2.6016 8.47138 2.86195L13.1381 7.52862C13.3984 7.78896 13.3984 8.21108 13.1381 8.47142L8.47138 13.1381C8.21103 13.3984 7.78892 13.3984 7.52858 13.1381C7.26823 12.8777 7.26823 12.4556 7.52858 12.1953L11.7238 8.00002L7.52858 3.80476C7.26823 3.54441 7.26823 3.1223 7.52858 2.86195Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGray);
export default __webpack_public_path__ + "static/media/arrow-right-gray.78f56e68895cab1584316f7245b0069d.svg";
export { ForwardRef as ReactComponent };